"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findLowestScoringCombinationIndex = void 0;
const findLowestScoringCombinationIndex = (order_ranking, allCombinationsIds) => {
    // Create a lookup object for order_ranking scores
    const scoreLookup = order_ranking.reduce((acc, { id, score }) => {
        acc[id] = score;
        return acc;
    }, {});
    let lowestTotalScore = Infinity;
    let lowestIndex = -1;
    // Loop through each combination
    allCombinationsIds.forEach((combination, index) => {
        // Calculate the total score for the current combination
        const totalScore = combination.reduce((total, { id, score }) => {
            const ranking_score = scoreLookup[id];
            if (score === undefined) {
                console.error(`Score not found for ID: ${id}`);
            }
            return total + (score * ranking_score || 0);
        }, 0);
        // Update the lowest score and index if needed
        if (totalScore < lowestTotalScore) {
            lowestTotalScore = totalScore;
            lowestIndex = index;
        }
    });
    return lowestIndex;
};
exports.findLowestScoringCombinationIndex = findLowestScoringCombinationIndex;
